import { module } from 'modujs';
import lottie from 'lottie-web';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        lottie.loadAnimation({
            container: this.el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: this.getData('path'),
            rendererSettings: {
                preserveAspectRatio: 'xMaxYMax meet',
                progressiveLoad: false,
                hideOnTransparent: false
            }
        });
    }
}
